var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentityCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 49,
    viewBox: "0 0 49 49",
    width: 49,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.3 12.9h-29.6a2.7 2.7 0 0 0 -2.7 2.7v17.6a2.7 2.7 0 0 0 2.7 2.7h29.6a2.7 2.7 0 0 0 2.7-2.7v-17.6a2.7 2.7 0 0 0 -2.7-2.7zm-.3 20h-29v-17h29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.48 23.626h.02a2.606 2.606 0 0 0 1.857-4.434 2.585 2.585 0 0 0 -1.836-.777 2.617 2.617 0 0 0 -2.621 2.585 2.6 2.6 0 0 0 2.585 2.626z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 27a10.516 10.516 0 0 0 -5.5-1.327 10.52 10.52 0 0 0 -5.5 1.327v3.962l11 .038z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 20h12v2h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 23h12v2h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 26h12v2h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 29h12v2h-12z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityCard);
export default __webpack_public_path__ + "static/media/identity-card.f9ac940f2516b29537b433afe0ec62e7.svg";
export { ForwardRef as ReactComponent };